module.exports = __webpack_public_path__ + "img/c01_buildingtechphilosophy_Normal_ua.ebed403f.webp";